import { computed, Directive, effect, ElementRef, HostListener, inject, input, model } from "@angular/core";
import { SideNavStatusEnum } from "../interfaces/side-nav-status.enum";
import { DOCUMENT } from "@angular/common";

@Directive({})
export abstract class ToggleSideNav {
  protected document = inject(DOCUMENT);
  protected el = inject<ElementRef<HTMLDivElement>>(ElementRef);

  protected readonly SIDE_NAV_DEFAULT_WIDTH = 292;
  protected readonly ACTION_BAR_DEFAULT_WIDTH = 60;

  sideNav = input.required<HTMLDivElement>();
  status = model.required<SideNavStatusEnum | null>();
  arrowEl = input<HTMLDivElement>();
  collapsedBtnOffset = input(5);

  actionBarWidth = computed(() => this.sideNav()?.querySelector<HTMLElement>("[icons-bar]")?.offsetWidth ?? this.ACTION_BAR_DEFAULT_WIDTH);

  readonly linksNavWidth = this.SIDE_NAV_DEFAULT_WIDTH;

  collabsedBtn = computed(() => (this.arrowEl() ? this.arrowEl() : this.el.nativeElement));

  @HostListener("click")
  expandNavbar() {
    this.calcSideNavStatus();
  }

  constructor() {
    effect(() => this.calcActionBtnPosition(this.status()));
  }

  protected calcSideNavStatus() {
    this.status.update(status => {
      return status === SideNavStatusEnum.collapse ? SideNavStatusEnum.expanded : SideNavStatusEnum.collapse;
    });
  }

  protected calcActionBtnPosition(status: SideNavStatusEnum | null) {
    let actionLeftPosition = +(this.collabsedBtn()?.style.insetInlineStart.split("px")[0] || this.actionBarWidth);
    if (status === SideNavStatusEnum.collapse || !status) {
      actionLeftPosition = this.actionBarWidth() + this.collapsedBtnOffset();
    } else {
      actionLeftPosition = this.linksNavWidth - ((this.collabsedBtn()?.offsetWidth || 25) + this.collapsedBtnOffset());
    }
    const _collabsedBtn = this.collabsedBtn();
    if (_collabsedBtn) {
      _collabsedBtn.style.insetInlineStart = `${actionLeftPosition}px`;
    }
  }
}
